import React from 'react'
import PropTypes from 'prop-types'
import { Input }  from 'sb-valuelink'

import Text from 'components/_new/typography/Text/Text'

import AddressField from '../AddressField/AddressField'

import s from './EditableAddressField.scss'


const EditableAddressField = ({ valueLink, ariaLabel }) => {

  const value = valueLink.value && valueLink.value !== 0 ? String(valueLink.value) : ''
  const valueLength = value.length + 2

  return Boolean(valueLink) && (
    <AddressField isEditable>
      <Input className={s.input} type="text" size={valueLength} valueLink={valueLink} aria-label={ariaLabel} />
      {
        Boolean(valueLink.validationError) && (
          <Text className={s.error} message={valueLink.validationError} color="error" size="12-16" />
        )
      }
    </AddressField>
  )
}

EditableAddressField.propTypes = {
  valueLink: PropTypes.object,
}


export default EditableAddressField
